import { BgColorPalette } from '@/constants';
import styled from 'styled-components';

export const CarrierMaskingStyled = styled.div`
  .cm-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.625rem 0;

    &:not(:first-child) {
      border-top: 1px solid ${BgColorPalette.SECONDARY_HOVER};
    }
  }

  .cm-empty {
    padding: var(--p-space-200) 0;
  }
`;
